import styles from "./strategic-planning.module.css";
import ServicoDetalheCover from "../../../components/ServicosComponents/ServicoDetalheCover/servico-detalhe-cover";
import { NavLink } from "react-router-dom";

const StrategicPlanning = () => {
  return (
    <main className={styles.servico_detalhe_main}>
      <ServicoDetalheCover
        title="Strategic Planning"
        alt="Cover da página Strategic Planning."
      />
      <section className={styles.descricao_section}>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Provemos suporte ao planejamento de projetos de dados de mundo real
            (RWD) incluindo a avaliação de viabilidade, considerando acesso a
            diferentes fontes de dados e conteúdo disponível em cada fonte.
            Também auxiliamos a elaboração de documentos formais para submissões
            e registro dos projetos.
          </p>
        </div>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Apoiamos o planejamento de divulgação de evidências de mundo real
            (RWE), com estruturação de cronograma levando em consideração prazos
            relacionados a eventos científicos relevantes.
          </p>
        </div>
        <div className={styles.btns_div}>
          <NavLink to="/produtos/masterclasses">
            <button className={styles.btn_produto}>
              {" Ver Masterclasses"}
            </button>
          </NavLink>
          <NavLink to="/produtos/rwe-analytics">
            <button className={styles.btn_produto}>
              {"Ver RWE Analytics"}
            </button>
          </NavLink>
        </div>
        <div className={styles.btns_divMobile}>
          <NavLink to="/produtos/masterclasses">
            <button className={styles.btn_produto}>
              {"<"}
            </button>
          </NavLink>
          <NavLink to="/produtos/rwe-analytics">
            <button className={styles.btn_produto}>
              {">"}
            </button>
          </NavLink>
        </div>
      </section>
    </main>
  );
};

export default StrategicPlanning;
